import React, { ReactNode } from 'react';
import { usePdfStatusManager } from '../hooks/usePdfStatusManager';
import { PdfStatusContext } from './PdfStatusContextDef';

interface PdfStatusProviderProps {
  children: ReactNode;
}

export const PdfStatusProvider: React.FC<PdfStatusProviderProps> = ({ children }) => {
  const pdfStatusManager = usePdfStatusManager();

  return (
    <PdfStatusContext.Provider value={pdfStatusManager}>
      {children}
    </PdfStatusContext.Provider>
  );
};

